import React from 'react';
import { translate } from 'react-i18next';
import {Button, Form, Input, Grid, Message, Label, Modal} from 'semantic-ui-react';

import AuthUtils from 'utils/AuthUtils.js';
import {colors, shadow, fontSizes, fonts, spacings} from 'style';

const style = {
    modal: {
    },
    column: {
        maxWidth: '400px'
    },
    form: {
        backgroundColor: 'white',
    },
    content: {
        marginLeft: 'auto',
        marginRight: 'auto',
        maxWidth: 'calc(100% - 50px)',
        height: '100%',
        color: colors.themeDarkerGrey,
    },
    bannerColumn: {
        padding: '0',
    },
    banner: {
        fontSize: fontSizes.h1,
        lineHeight: fontSizes.h1,
    },
    logo: {
        color: colors.themeTeal,
        paddingTop: '',
        fontSize: '1.3em',
        lineHeight: '1.3em',
    },
    welcome: {
        display: 'inline',
        color: colors.themeBlue,
        fontSize: fontSizes.h2,
        lineHeight: fontSizes.h2,
    },  
    errorLabel: {
        position: 'relative',
        margin: '0 10px -100% 0',
        float: 'right',
        right: '100%',
        bottom: '30px',
    },
    errorLabelBottom: {
    },
    field: {
        position: 'relative',
    },
    input: {
        paddingLeft: '0px',
        borderTop: 'none',
        borderRight: 'none',
        borderLeft: 'none',
        borderBottom: '1px solid ' + colors.themeTeal,
        color: colors.themeTeal,
        boxShadow: 'none',
        borderRadius: '0',
        ...fonts.body,
    },
    inputError: {
        borderBottom: '1px solid ' + colors.errorRed,
        color: colors.errorRed,
    },
    inputLabel: {
        paddingTop: '10px',
        textAlign: 'left',
        color: colors.themeDarkerGrey,
        ...fonts.body,
    },
    topRow: {
        paddingBottom: '0',
    },
    topLink: {
        ...fonts.body,
        lineHeight: '1.5em',
        paddingTop: '20px',
        paddingRight: '0px',
        paddingBottom: spacings.base,
    },
    row: {
        padding: '0',
    },
    tealButton: {
        fontWeight: 'normal',
        ...fonts.body,
        lineHeight: '1.5',
        borderRadius: '100px',
        backgroundColor: colors.themeTeal,
        color: '#fff',
        width: '330px',
        boxShadow: shadow,
        maxWidth: '100%',
    },
    greyButton: {
        fontWeight: 'normal',
        ...fonts.body,
        lineHeight: '1.5',
        borderRadius: '100px',
        backgroundColor: colors.themeDarkerGrey,
        color: '#fff',
        width: '330px',
        opacity: '0.50',
        boxShadow: 'rgba(0, 0, 0, 0.5) 0px 2px 4px 0px',
        maxWidth: '100%',
    },
    anchor: {
        color: colors.themeBlue,
        textDecoration: 'underline',
    },
}

const ChangePasswordModal = ({t,
                              password, 
                              passwordConfirm, 
                              oldPassword,
                              passwordError, 
                              passwordConfirmError, 
                              oldPasswordError, 
                              error,
                              valid,
                              onPasswordChange, 
                              onPasswordConfirmChange, 
                              onOldPasswordChange, 
                              onSubmit, 
                              onBlur, 
                              onClose}) => (
    <Modal closeIcon open size="small" onClose={onClose} style={style.modal}>
        <Modal.Header style={style.header}>{t('settings:::change_password')}</Modal.Header>
        <Modal.Content>
            <Form style={style.form} noValidate onSubmit={onSubmit}>
                <Grid style={style.content} textAlign="center">
                    <Grid.Row> 
                        <Grid.Column style={style.column} verticalAlign="middle">

                            <div style={style.inputLabel}>{t('Old Password')}</div>
                            <Form.Field style={style.field}>        
                                <input 
                                    style={{...style.input, 
                                            ...(oldPasswordError.length ? style.inputError : {})}}
                                    type="password"
                                    name="oldPassword"
                                    value={oldPassword}
                                    onChange={onOldPasswordChange}
                                    onBlur={onBlur}
                                    required
                                />
                                {oldPasswordError.length > 0 && 
                                    <Label basic color="red" pointing style={style.errorLabelBottom}>{oldPasswordError}</Label>
                                }
                            </Form.Field>        

                            <div style={style.inputLabel}>{t('New Password')}</div>
                            <Form.Field style={style.field}>        
                                <input 
                                    style={{...style.input, 
                                            ...(passwordError.length ? style.inputError : {})}}
                                    type="password"
                                    name="userPassword"
                                    value={password}
                                    onChange={onPasswordChange}
                                    onBlur={onBlur}
                                    placeholder={t('Password must be at least {{length}} characters', {length: AuthUtils.minPasswordLength})} 
                                    required
                                />
                                {passwordError.length > 0 && 
                                    <Label basic color="red" pointing style={style.errorLabelBottom}>{passwordError}</Label>
                                }
                            </Form.Field>        

                            <div style={style.inputLabel}>{t('Confirm Password')}</div>
                            <Form.Field style={style.field}>        
                                <input 
                                    style={{...style.input, 
                                            ...(passwordConfirmError.length ? style.inputError : {})}}
                                    type="password"
                                    name="userPasswordConfirm"
                                    value={passwordConfirm}
                                    onChange={onPasswordConfirmChange}
                                    onBlur={onBlur}
                                    placeholder={t('Password must be at least {{length}} characters', {length: AuthUtils.minPasswordLength})} 
                                    required
                                />
                                {passwordConfirmError.length > 0 &&
                                    <Label basic color="red" pointing style={style.errorLabelBottom}>{passwordConfirmError}</Label>
                                }
                            </Form.Field>        

                            {error.length > 0 &&
                                <Message negative>{error}</Message>
                            }
                            <Button style={valid ? style.tealButton : style.greyButton} type="submit" >{t('Save')}</Button>
                            <br />
                            <br />
                            <br />
                        </Grid.Column>
                    </Grid.Row> 
                </Grid>
            </Form>
        </Modal.Content>
    </Modal>
);

export default translate(['authentication', 'settings'])(ChangePasswordModal);



// WEBPACK FOOTER //
// ./src/modules/settings/ChangePasswordModal.js